import { render, staticRenderFns } from "./change_shifts_record.vue?vue&type=template&id=06c7236a&"
import script from "./change_shifts_record.vue?vue&type=script&lang=ts&"
export * from "./change_shifts_record.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports